function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_820",
  "data-name": "Group 820",
  transform: "translate(-327 -315)"
}, React.createElement("circle", {
  id: "Ellipse_2245",
  "data-name": "Ellipse 2245",
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  transform: "translate(327 315)",
  fill: "#adadad"
}), React.createElement("circle", {
  id: "Ellipse_2246",
  "data-name": "Ellipse 2246",
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  transform: "translate(337 315)",
  fill: "#adadad"
}), React.createElement("circle", {
  id: "Ellipse_2247",
  "data-name": "Ellipse 2247",
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  transform: "translate(347 315)",
  fill: "#adadad"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 25,
    height: 5,
    viewBox: "0 0 25 5"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/admin_static/media/more-dots.ff37b9ad.svg";
export { SvgComponent as ReactComponent };